module.exports = __webpack_public_path__ + "static/media/26.f058f01c.png";